import React from 'react'
import { Modal, Input, Select } from 'antd'
import PropTypes from 'prop-types'

import { dataBanks } from './../../components/filter'

const ModalReadyToRefund = ({ visible, modalOk, closeModal, changeRefundBank, changeRefundInput, refund }) => (
  <Modal
    title="Ready to Refund"
    visible={visible}
    onOk={modalOk}
    onCancel={closeModal}
    width={325}
  >
    <div className="block">
      <label>Jumlah Refund</label>
      <Input onChange={e => changeRefundInput(e, 'amount')} value={refund.amount} />
    </div>
    <div className="block">
      <label>Bank</label>
      <Select onChange={changeRefundBank} style={{ width: '100%' }} value={refund.bank}>
        {dataBanks.map(x => (
          <Select.Option key={x} value={x}>
            {x}
          </Select.Option>
        ))}
      </Select>
    </div>
    <div className="block">
      <label>Nomor Rekening Tujuan</label>
      <Input type="number" onChange={e => changeRefundInput(e, 'bankNo')} value={refund.bankNo} />
    </div>
    <div className="block">
      <label>Nama Pemilik Rekening</label>
      <Input onChange={e => changeRefundInput(e, 'ownerName')} value={refund.ownerName} />
    </div>
  </Modal>
)

ModalReadyToRefund.propTypes = {
  visible: PropTypes.bool.isRequired,
  modalOk: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  changeRefundBank: PropTypes.func.isRequired,
  changeRefundInput: PropTypes.func.isRequired,
  refund: PropTypes.object.isRequired,
}

export default ModalReadyToRefund



// WEBPACK FOOTER //
// src/pages/order/modalReadyToRefund.js